import { cva as e } from "class-variance-authority";
// src/design/empty-state/style.ts
var t = e("flex items-center justify-center w-full", {
	variants: { size: {
		sm: "py-8",
		md: "py-12",
		lg: "py-16"
	} },
	defaultVariants: { size: "md" }
}), n = e("flex flex-col items-center gap-4 max-w-md text-center", {
	variants: { size: {
		sm: "gap-3 max-w-sm",
		md: "gap-4 max-w-md",
		lg: "gap-5 max-w-lg"
	} },
	defaultVariants: { size: "md" }
}), r = e("flex items-center justify-center rounded-full", {
	variants: {
		size: {
			sm: "h-12 w-12 text-md",
			md: "h-16 w-16 text-xl",
			lg: "h-20 w-20 text-2xl"
		},
		variant: {
			default: "bg-muted text-muted-foreground",
			primary: "bg-secondary text-primary",
			success: "bg-success/10 text-success-text",
			warning: "bg-warning/10 text-warning-text",
			error: "bg-destructive/10 text-destructive",
			info: "bg-info/10 text-info-text"
		}
	},
	defaultVariants: {
		size: "md",
		variant: "default"
	}
}), i = e("font-semibold text-foreground", {
	variants: { size: {
		sm: "text-sm",
		md: "text-xl",
		lg: "text-lg"
	} },
	defaultVariants: { size: "md" }
}), a = e("text-muted-foreground", {
	variants: { size: {
		sm: "text-xs",
		md: "text-sm",
		lg: "text-base"
	} },
	defaultVariants: { size: "md" }
}), o = e("flex items-center gap-2", {
	variants: { size: {
		sm: "gap-1.5",
		md: "gap-2",
		lg: "gap-3"
	} },
	defaultVariants: { size: "md" }
}), s = (e) => ({
	root: (n) => t({
		size: e?.size,
		...n
	}),
	content: (t) => n({
		size: e?.size,
		...t
	}),
	indicator: (t) => r({
		size: e?.size,
		variant: e?.variant,
		...t
	}),
	title: (t) => i({
		size: e?.size,
		...t
	}),
	description: (t) => a({
		size: e?.size,
		...t
	}),
	actions: (t) => o({
		size: e?.size,
		...t
	})
});
export { o as actionsStyles, n as contentStyles, a as descriptionStyles, s as getStyles, r as indicatorStyles, t as rootStyles, i as titleStyles };

//# sourceMappingURL=style.js.map